import { z, isoZ } from 'my-zod'
import { ManualCreditAdjustmentReasonCodeOptions } from '../../finance/transfers'

export const manualCreditAdjustmentsModel = z.object({
  id: z.string().uuid(),
  customerId: z.string().uuid(),
  subscriptionCreditImpact: z
    .number()
    .nullable()
    .refine((v) => !!v && v !== 0, 'Must supply a value'),
  reason: z.string().min(5).nonempty(),
  reasonCode: z
    .enum(ManualCreditAdjustmentReasonCodeOptions)
    .nullable()
    .refine((v) => !!v, 'Please pick a reason code'),
  creditEventId: z.number().nullable(),
  userId: z.number().nullable(),
  createdDate: isoZ.instant().nullable()
})

export type manualCreditAdjustmentsModel = z.infer<typeof manualCreditAdjustmentsModel>
